define('v3/Common/Components/SubjectsDropdown/SubjectsDropdown.Component',[
	'knockout',
	'lodash',
	'v3/Common/Components/SubjectsDropdown/Services/subjectService',
	'v3/Common/Services/pageStateService',
	'text!v3/Common/Components/SubjectsDropdown/SubjectsDropdown.Component.html',
	'v3/Common/Bindings/Select.Binding'
], function (ko, _, subjectService, pageStateService, htmlString) {
	var pageStateSubjectId = pageStateService.getNumberObservable('subjectId');
	if (pageStateSubjectId()) {
		subjectService.saveSubjectId(pageStateSubjectId());
	}

	function validateParams (params) {
		params.filter || (params.filter = 'educationPlanExistsForClass');
		params.loadState = params.loadState !== false;
	}

	function SubjectsDropdownViewModel (params) {
		var self = this;

		var fetchSubjectsDeferred;
		var selectedSubjectSubscriber;

		validateParams(params);

		self.params = params;

		self.subjects = ko.observableArray();

		self.selectedSubjectId =
			ko.isObservable(params.selectedSubjectId)
				? params.selectedSubjectId
				: ko.observable(null);

		self.disabled = params.disabled || false;

		switch (params.filter) {
		case 'educationPlanExistsForClass':
			fetchSubjectsDeferred = subjectService.getSubjectsWhereEducationPlanExistsForClass();
			break;
		case 'availableForClass':
			fetchSubjectsDeferred = subjectService.getSubjectsAvailableForClass();
			break;
		default:
			throw new Error('Not supported params.filter parameter: ' + params.filter);
		}

		fetchSubjectsDeferred
			.done(function (subjects) {
				if (params.noSelectionCaption) {
					var noSelectionCaptionExists = _.some(subjects, ['id', null]);
					if (!noSelectionCaptionExists) {
						subjects.unshift({ id: null, name: params.noSelectionCaption });
					}
				}

				if (subjects.length === 0 && params.noSubjectsCaption) {
					subjects.unshift({ id: null, name: params.noSubjectsCaption });
				}

				self.subjects(subjects);

				function selectFirstOrNull () {
					if (subjects.length > 0) {
						self.selectedSubjectId(subjects[0].id);
					} else {
						self.selectedSubjectId(null);
					}
				}

				function trySelectSubjectNameInParams (subjectId) {
					if (ko.isObservable(params.selectedSubjectName)) {
						var subject = _.find(self.subjects(), { id: subjectId });
						if (subject != null) {
							params.selectedSubjectName(subject.name);
						}
					}
				}

				function trySelectSubjectIconNameInParams (subjectId) {
					if (ko.isObservable(params.selectedSubjectIconName)) {
						var subject = _.find(self.subjects(), { id: subjectId });
						if (subject != null) {
							params.selectedSubjectIconName(subject.iconName);
						}
					}
				}

				var initialSubjectId = self.selectedSubjectId() || pageStateSubjectId() || subjectService.getSubjectId();
				if (initialSubjectId && params.loadState && _.some(subjects, { id: initialSubjectId })) {
					self.selectedSubjectId(initialSubjectId);
				} else {
					selectFirstOrNull();
				}

				pageStateSubjectId(self.selectedSubjectId());
				trySelectSubjectNameInParams(self.selectedSubjectId());
				trySelectSubjectIconNameInParams(self.selectedSubjectId());

				selectedSubjectSubscriber = self.selectedSubjectId.subscribe(function (subjectId) {
					if (!subjectId) return;

					subjectService.saveSubjectId(subjectId);
					pageStateSubjectId(subjectId);

					trySelectSubjectNameInParams(subjectId);
					trySelectSubjectIconNameInParams(self.selectedSubjectId());
				});
			})
			.always(function () {
				if (ko.isObservable(params.isLoaded)) {
					params.isLoaded(true);
				}
			});

		self.dispose = function () {
			if (selectedSubjectSubscriber) selectedSubjectSubscriber.dispose();
		};
	}

	return { viewModel: SubjectsDropdownViewModel, template: htmlString };
});
